import { FORM_FIELDS } from '../../../../../../../../constants';
import { getValidationSchema } from '../../../../../../../form/common.validators';

export const schema = () =>
    getValidationSchema([
        FORM_FIELDS.MONTHLY_SALARY,
        FORM_FIELDS.REGION,
        FORM_FIELDS.REGION_LOCATION_ROUTE,
        FORM_FIELDS.FIRST_NAME,
        FORM_FIELDS.LAST_NAME,
        FORM_FIELDS.MIDDLE_NAME,
        FORM_FIELDS.EMAIL,
        FORM_FIELDS.PHONE,
    ]);
